import { compose, withHandlers } from 'recompose';
import { withDataLayerPush } from '../withDataLayerPush';

// This push dataLayer by method
// eslint-disable-next-line
export const withDataLayerProductDetailView = compose(
  withDataLayerPush,
  withHandlers({
    dataLayerProductDetailView: ({ dataLayerPush }) => ({
      id, currency, name, numberOfPages, price, pricePerPage, productName, category, variant
    }) => {
      dataLayerPush({
        event: 'ProductDetailView',
        ecommerce: {
          currencyCode: currency,
          detail: {
            products: [
              {
                id: id,
                name: name,
                numberOfPages,
                price: price,
                pricePerPage,
                productName,
                category: category,
                variant: variant
              }
            ]
          }
        }
      });
    },
  }),
);



// WEBPACK FOOTER //
// ./src/Common/GTM/ECommerceTracking/withDataLayerProductDetailView.js